import {Constructor} from "../../../global/constructor";
import ObjectModelPermission from "~/models/objectModelPermissions/objectModelPermission";
import ObjectModelBuilderModel from "~/models/tracked/objectModelBuilderModel";
import ObjectModel from "~/models/objectModel";

interface IObjectModelPermittable {
  rootName: string;
}

export default function ObjectModelPermittable<TBase extends Constructor<ObjectModelBuilderModel>>(Base: TBase) {
  return class extends Base implements IObjectModelPermittable {
    parent: ObjectModel;
    rootName: string;

    get permissionsArray(): ObjectModelPermission[] {
      return this.rootModel.permissionsArray.filter(permission => permission.permittable_client_id === this.client_id);
    }

    afterDestroy() {
      super.afterDestroy();
      this.permissionsArray.forEach(permission => permission.destroy());
      this.parent.updateSortOrder(this.rootName);
    }
  }
}